import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import * as moment from 'moment';
import { formatTime, currentDate } from 'utilities/util';

@Component({
  selector: 'app-informes-calidad',
  templateUrl: './informes-calidad.component.html',
  styleUrls: ['./informes-calidad.component.scss']
})
export class InformesCalidadComponent implements OnInit {
  
  public dtOptions;
  public fechaInicio :string;
  public fechafin :string;
  public tableOpts;
  public dtTrigger:Subject<void>;
  public fechaInicialF:string;
  public fechaFinalFormateada:string;
  @ViewChild(DataTableDirective, {static:true})
  tabla: DataTableDirective;;
  constructor() {
    this.dtTrigger = new Subject();
    this.fechaInicio = currentDate();
    this.fechafin = currentDate()
    this.dtTrigger.next();
    this.tableOpts = [];
  }
  search(){

  }
  ngOnInit() {
  }

  
  /**
   * rerender
   */
  public rerender() {
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destruimos la instancia del datatable para re renderizar la tabla
      dtInstance.destroy();
      // Disparamos el evento de el subject para que la tabla vuelva a instanciarse
      this.dtTrigger.next();
    })
  }

  ngAfterViewInit(){
    this.dtTrigger.next();

  }

  // tslint:disable-next-line: use-lifecycle-interface
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.dtTrigger.unsubscribe();
  }
s

}
